// https://app.growthbook.io/features/copy_feature_variables
export const BOGO_OFFER_VARIABLES_FLAG_NAME = 'copy_feature_variables'

// Feature variables
export const BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME = 'banner_offer_slogan_blue'
export const OFFER_SLOGAN_YELLOW_VARIABLE_NAME = 'offer_slogan_yellow'
